import { useEffect, useState } from 'react'
import {
  getInstallSupportLevel,
  hasNativeInstallPrompt,
  isInstalled,
  subscribe,
  triggerNativeInstall,
} from '@/lib/install-prompt'

export function useInstallPrompt() {
  const [, setTick] = useState(0)

  useEffect(() => {
    return subscribe(() => setTick((value) => value + 1))
  }, [])

  return {
    installed: isInstalled(),
    canInstallNatively: hasNativeInstallPrompt(),
    supportLevel: getInstallSupportLevel(),
    install: triggerNativeInstall,
  }
}
